import { createClient } from '@supabase/supabase-js';

// Support both Vite (import.meta.env) and Node/Expo (process.env)
const getEnvVar = (viteKey: string, expoKey: string, nodeKey: string): string => {
  // Vite environment
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return (import.meta.env as any)[viteKey] || '';
  }
  // Node/Expo environment
  if (typeof process !== 'undefined' && process.env) {
    return process.env[expoKey] || process.env[nodeKey] || '';
  }
  return '';
};

const SUPABASE_URL = getEnvVar('VITE_SUPABASE_URL', 'EXPO_PUBLIC_SUPABASE_URL', 'SUPABASE_URL');
const SUPABASE_ANON_KEY = getEnvVar('VITE_SUPABASE_ANON_KEY', 'EXPO_PUBLIC_SUPABASE_ANON_KEY', 'SUPABASE_ANON_KEY');

console.log('=== Supabase Client Initialization ===');
console.log('URL:', SUPABASE_URL);
console.log('Key:', SUPABASE_ANON_KEY ? 'Present' : 'Missing');

let supabaseClient: any = null;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.warn('⚠️  Missing Supabase configuration. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
  // Create a dummy client that won't error during initialization
  const authError = new Error('Supabase configuration is missing');
  supabaseClient = {
    auth: {
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
      getUser: async () => ({ data: { user: null }, error: null }),
      getSession: async () => ({ data: { session: null }, error: null }),
      signOut: async () => ({ error: null }),
      signInWithPassword: async () => ({ data: { user: null, session: null }, error: authError }),
      signUp: async () => ({ data: { user: null, session: null }, error: authError }),
      resetPasswordForEmail: async () => ({ data: {}, error: authError }),
      updateUser: async () => ({ data: { user: null }, error: authError }),
    },
  } as any;
} else {
  supabaseClient = createClient(
    SUPABASE_URL,
    SUPABASE_ANON_KEY,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    }
  );
  console.log('✓ Supabase client initialized');
}

export { supabaseClient };
export const auth = supabaseClient.auth;
